import type { ReactNode } from "react";
import { SheetClose } from "@/components/ui/sheet";
import { Link, type LocalizedRoute } from "@/i18n/navigation";

export const MobileMenuLink = ({
  href,
  icon,
  label,
  testData,
}: {
  href: LocalizedRoute;
  icon: ReactNode;
  label: string;
  testData?: string;
}) => (
  <SheetClose asChild>
    <Link
      className="flex w-full items-center gap-2 rounded-lg p-4 text-base text-text leading-6"
      data-pw={testData}
      href={href}
    >
      {icon}
      <span>{label}</span>
    </Link>
  </SheetClose>
);
